import {Component, OnDestroy, OnInit} from '@angular/core';
import {User} from '../../../../stores/user/user.model';
import {Subscription} from 'rxjs';
import {environment} from '../../../../../../environments/environment';
import {SessionQuery} from '../../../../stores/session/session.query';

@Component({
  selector: 'app-coordinator-sidebar',
  templateUrl: './coordinator-sidebar.component.html',
  styleUrls: ['./coordinator-sidebar.component.scss']
})
export class CoordinatorSidebarComponent implements OnInit, OnDestroy {
  activeId = 1;
  user: User;
  userSubscription: Subscription;

  env = environment;

  constructor(private sessionQuery: SessionQuery) {
  }

  ngOnInit(): void {
    this.userSubscription = this.sessionQuery.getUserObservable().subscribe(user => {
      this.user = user;
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}
